import {createSlice, PayloadAction} from "@reduxjs/toolkit";

interface ResponseAddTestState {
    success: boolean;
    file: string;
    fileName: string;
    questionId: number;
    error: string | null;
    errors: {
        [key: string]: string[];
    };
}

const initialState: ResponseAddTestState = {
    success: false,
    file: '',
    fileName: '',
    questionId: 0,
    error: null,
    errors: {},
};

const responseAddFileSlice = createSlice({
    name: "responseAddFile",
    initialState,
    reducers: {
        setAddFile: (state, action: PayloadAction<ResponseAddTestState>) => {
            state.success = action.payload.success;
            state.file = action.payload.file;
            state.fileName = action.payload.fileName;
            state.questionId = action.payload.questionId
            state.error = null;
            state.errors = {};
        },
        setErrorsFile: (
            state,
            action: PayloadAction<{
                success: boolean;
                error: string;
                errors: { [key: string]: string[] };
            }>
        ) => {
            state.error = action.payload.error;
            state.errors = action.payload.errors;
            state.success = action.payload.success;
        },
        resetAddFile: (state) => {
            state.success = false;
            state.file = '';
            state.fileName = '';
            state.questionId = 0;
            state.error = null;
            state.errors = {};
        },
    },
});


export const {setErrorsFile, setAddFile,resetAddFile} = responseAddFileSlice.actions;

export const responseAddFileReducer = responseAddFileSlice.reducer;
